import { type TextareaHTMLAttributes } from 'react';
import type React from 'react';
type TextareaProps = {
  label?: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  size?: 'lg' | 'md' | 'sm';
  error?: string | undefined;
  className?: string;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea: React.FC<TextareaProps> = ({ label, onChange, error, size = 'lg', readOnly = false, ...props }) => {
  const className = `flex flex-col  mt-4 ${props.className} dark:text-white `;
  const textAreaClassName = `no-scrollbar text-sm resize-none dark:bg-grey-900 mt-2 rounded-md ${error ? 'border-red-500' : 'border-grey-400'}  outline-none border p-2 overflow:none font-Inter ${size === 'lg' ? 'h-40' : size === 'md' ? 'h-32' : 'h-24'} ${readOnly ? 'bg-grey-50' : 'bg-white'}`;
  return (
    <div className={className}>
      {label && <label className='text-sm font-semibold font-Inter' htmlFor={props.id}>{label}</label>}
      <textarea readOnly {...props} className={textAreaClassName} onChange={onChange} />
    </div>
  );
};

export default Textarea;
